import React, { useState } from 'react';
import { OverlayTrigger, Popover, Tooltip } from 'react-bootstrap';
import styles from './MileageSaarathi.module.css';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import ChartLoader from './Loader_MS_bus';
import "../style.css"

function CustomPopover({ value, keyName: metricType, filterdata }) {
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [popoverData, setPopoverData] = useState([]);
    const [loading, setLoading] = useState(false);

    const CustomTooltip = ({ tooltipText }) => {
        return (
            <OverlayTrigger
                placement="top"
                overlay={
                    <Tooltip id="tooltip-dynamic" className="custom-tooltip">
                        <div style={{ width: "200px" }}>
                            <div className="text-start">
                                <i>Recommendation</i>
                            </div>
                            <div className="text-start">
                                <span style={{ fontSize: "11px" }}>{tooltipText}</span>
                            </div>
                        </div>
                    </Tooltip>
                }
            >
                <i
                    className={`fas fa-info-circle ${styles.summary_icons}`}

                ></i>
            </OverlayTrigger>
        );
    };

    const compliantTag = (value) => {
        let isCompliant = false;
        // if (value != 0) {
        if (value === '-' || value === null || value === undefined) {
            return <span>{value}</span>;
            // }
        }


        const num = Number(value);
        switch (metricType) {
            case 'Speed':
                isCompliant = num > 25;
                break;
            case 'Idling':
                isCompliant = num < 22;
                break;
            case 'AccelerationSpeed':
                isCompliant = num > 19;
                break;
            case 'Regeneration':
                isCompliant = num > 8.72;
                break;
            case 'RPM':
                isCompliant = num > 17;
                break;
            case 'Costing':
                isCompliant = num > 9.10;
                break;
            default:
                return <span>{value?.toFixed(2)}</span>;
        }

        const label = isCompliant ? 'Compliant' : 'Non-Compliant';
        const badgeStyle = {
            padding: '2px 6px',
            borderRadius: '4px',
            fontWeight: '600',
            fontSize: '12px',
            color: isCompliant ? '#27aa57' : '#c92a31',
            backgroundColor: isCompliant ? '#CEECD9' : '#f4d3d4',
            border: 'none',
        };

        return (
            <span style={badgeStyle}>
                {label}
                <CustomTooltip tooltipText={isCompliant ? "Vehicle driven as per recommendation" : "Vehicle has not been driven as per recommendation"} />
            </span>
        );
    };

    const handlePopoverOpen = () => {
        setLoading(true);
        let apiEnd =
            metricType === 'Speed'
                ? 'speed'
                : metricType === 'AccelerationSpeed'
                    ? 'Accelerator_Pedal'
                    : metricType === 'Idling'
                        ? 'Idling'
                        : metricType === 'Regeneration'
                            ? 'Regeneration' :
                            metricType === 'RPM'
                                ? 'day_wise_rpm' :
                                metricType === 'Costing'
                                    ? 'day_wise_coasting' : "";

        fetchData(
            {
                url: API_URL_MAIN + `mileage_sarathi_ace/${apiEnd}`,
                body: {
                    filterdata
                }
            },
            (data) => {
                // setPopoverData(data?.groupby_date.buckets || []); // assuming data format Accelerator_Pedal Idling Regeneration
                setLoading(false);
                let formateData = []
                if (metricType === 'Speed') {
                    formateData = data.groupby_date.buckets?.map((item) => ({ date: item.key_as_string, value: item?.Speed?.value }))
                }
                else if (metricType === 'AccelerationSpeed') {
                    formateData = data.groupby_date.buckets?.map((item) => ({ date: item.key_as_string, value: item?.Accelerator_Pedal?.value }))
                }
                else if (metricType === 'Idling') {
                    formateData = data.groupby_date.buckets?.map((item) => ({ date: item.key_as_string, value: item?.Idling?.value }))
                }
                else if (metricType === 'Regeneration') {
                    formateData = data.groupby_date.buckets?.map((item) => ({ date: item.key_as_string, value: item?.Regeneration?.value }))
                }
                else if (metricType === 'RPM') {
                    formateData = data.groupby_date.buckets?.map((item) => ({ date: item.key_as_string, value: item?.RPM?.value }))
                }
                else if (metricType === 'Costing') {
                    formateData = data.groupby_date.buckets?.map((item) => ({ date: item.key_as_string, value: item?.Coasting?.value }))
                }
                else {
                    formateData = []
                }
                setPopoverData(formateData)
            }
        );
    };

    const renderPopover = (
        <Popover id={`popover-${value}`}>
            <Popover.Body>
                <div className="modal-body p-0" style={{ overflowY: 'scroll', height: '250px', width: '300px' }}>
                    <table className="table table-bordered table-hover mb-0">
                        <thead>
                            <tr style={{ backgroundColor: '#fff', color: 'gray', position: 'sticky', top: -1 }}>
                                <td colSpan={2} className='table-cell'><i>Bifurcation: {metricType}</i></td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                loading ? (
                                    <tr><ChartLoader /></tr>
                                ) :
                                    popoverData.length ? (
                                        popoverData.map((item, index) => {
                                            return (
                                                <tr key={index} style={{ backgroundColor: '#fff' }}>
                                                    <td>{item.date}</td>
                                                    <td>{compliantTag(item.value)}</td>
                                                </tr>
                                            )
                                        })
                                    ) :
                                        <tr><td colSpan={2} className='text-center table-cell'>No Data Found</td></tr>}
                        </tbody>
                    </table>
                </div>
            </Popover.Body>
        </Popover>
    );

    return (
        <OverlayTrigger
            trigger="click"
            placement="left"
            overlay={renderPopover}
            onEnter={handlePopoverOpen}
            rootClose
        >
            <i className={`fas fa-info-circle ${styles.summary_icons}`}></i>
        </OverlayTrigger>
    );
}

export default CustomPopover;
